import { atom } from "jotai";

export const isEditingEnabledAtom = atom(false);
